module.exports = __webpack_public_path__ + "static/img/bheight.ee796888.png";